// add all the elements inside modal which you want to make focusable
const focusableElements
 = 'a, button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

/**
 * ModalMgr class is handle modal windows creation and displaying
 * for various overflow menu items
 * @class {ModalMgr}
 */
export default class ModalMgr {
    $app: any;

    constructor(app) {
        this.$app = app;
    }

    /**
     * Will handle the display of info modal
     * @param {string}  html string
     */
    displayInfoModalWindow(content) {
        content = content || "";
        this.$app.shoutui.getLayoutEl().showInfoModalView(content);
        this.setAriaReaderTextOfInfoModal(content);
    }

    /**
     * Will set content in aria-reader after formating
     * @param {string}  html string
     */
    setAriaReaderTextOfInfoModal(content) {
        let ariaReaderText = content.replace(/(<([^>]+)>)/ig, ""); // remove html tags from string
        ariaReaderText = ariaReaderText.replace(/(\r\n|\n|\r)/gm, "."); // replace new line with period
        ariaReaderText = ariaReaderText.replace(/\s+/g, " "); // replace multiple white spaces with single space
        this.$app.getStateMgr().setState({ ariaReaderSay: ariaReaderText });
    }

    /**
     * Will show email transcript window
     */
    requestEmail() {
        this.$app.shoutui.getLayoutEl().showEmailModal();
    }

    /**
     * Shows File Upload Modal in Layout
     */
    showFileUploadModal() {
        this.$app.shoutui.getLayoutEl().showFileUploadModal();
    }

    /**
     * Hides File Upload Modal in Layout
     */
    hideFileUploadModal() {
        this.$app.shoutui.getLayoutEl().hideFileUploadModal();
    }

    /**
     * Set focus within the modal window on press Tab or Shift + Tab
     * @param {HTMLElement} modalElement modal window element
     * @returns {void}
     */
    static setFocusWithinModalWindow(modalElement) {
        // All the focusable  element of modal window
        const modalFocusableContent = modalElement.querySelectorAll(focusableElements);

        // All the focusable  element of documents
        const documentFocusableContent = document.querySelectorAll(focusableElements);

        // Setting negative tab index on element of documents
        for (let i = 0, tabIndexVal; i < documentFocusableContent.length; i++) {
            tabIndexVal = documentFocusableContent[i].getAttribute("tabindex") || 0;

            if (tabIndexVal != "-1") {
                documentFocusableContent[i].setAttribute("tabindex", "-1");

                /**
                 * Creating custom data attribute  to track all the elements
                 * where we applied negative tabindex values, on closing modal
                 * we remove negative tabindex using this custome attribute
                 */
                documentFocusableContent[i].setAttribute("data-custom-index", tabIndexVal);
            }
        }

        // Setting tab index on elements of modal to make them focusable
        for (let j = 0; j < modalFocusableContent.length; j++) {
            modalFocusableContent[j].setAttribute("tabindex", 0);
        }
    }

    /**
     * This method remove negative tab index on document elements
     * after closing modal window
     */
    static removeNegativeTabIndexOnClosingModal() {
        // All the elements of document with custom attribute "data-custom-index"
        const documentFocusableContent = document.querySelectorAll("[data-custom-index]");

        for (let i = 0, tabIndexVal; i < documentFocusableContent.length; i++) {
            tabIndexVal = documentFocusableContent[i].getAttribute("data-custom-index");
            documentFocusableContent[i].setAttribute("tabindex", tabIndexVal);
            documentFocusableContent[i].removeAttribute("data-custom-index");
        }
    }

    static getFocusableContent(modalElement: any){
        return modalElement.querySelectorAll(focusableElements);
    }

    /**
     *  Tab click event to handle the focus
     */
    static onTab(e: Event, modalElement: any) {
        let modalFocusableContent = this.getFocusableContent(modalElement);

        const lastFocusableElement = modalFocusableContent[modalFocusableContent.length - 1];

        if(document.activeElement === lastFocusableElement){
            modalFocusableContent[0].focus();
            e.preventDefault();
        }
    }

    /**
     *  Shift+Tab click event to handle the focus
     */
    static onShiftTab(e: Event, modalElement: any) {
        let modalFocusableContent = this.getFocusableContent(modalElement);

        const lastFocusableElement = modalFocusableContent[modalFocusableContent.length - 1];

        if(document.activeElement === modalFocusableContent[0]){
            lastFocusableElement.focus();
            e.preventDefault();
        }
    }
}
